import type { RecordingStatus } from '@/app-shell/rpa/recorder/model/types';
import type { UploadStage } from '@heidi/plugin-rpa';

const RECORDING_STATUS_BY_UPLOAD_STAGE: Partial<Record<UploadStage, RecordingStatus>> = {
  ready: 'ready',
  failed: 'failed',
  polling: 'polling',
};

export function recordingStatusFromUploadStage(stage: UploadStage): RecordingStatus {
  return RECORDING_STATUS_BY_UPLOAD_STAGE[stage] ?? 'uploading';
}
